export const EXPENSE_CATEGORY = [
  { value: "Automobiles", label: "Automobiles" },
  { value: "Equipments", label: "Equipments" },
  { value: "Home office", label: "Home office" },
  { value: "Insurance", label: "Insurance" },
  { value: "Janitorial/Housekeeping", label: "Janitorial/Housekeeping" },
  { value: "Legal and Professional Services", label: "Legal and Professional Services" },
  { value: "Logistics", label: "Logistics" },
  { value: "Maintenance and Repairs", label: "Maintenance and Repairs" },
  { value: "Marketing and Advertising", label: "Marketing and Advertising" },
  { value: "Rent", label: "Rent" },
  { value: "Salaries & Wages", label: "Salaries and Wages" },
  { value: "Taxes and Licenses", label: "Taxes and Licenses" },
  { value: "Travel", label: "Travel" },
  { value: "Utilities", label: "Utilities" },
  { value: "Others", label: "Others" },
];

export const TABLE_HEAD = [
  { label: "Item/Description", key: "name", toLowerCase: () => "name" },
  { label: "Quantity", key: "quantity", toLowerCase: () => "quantity" },
  { label: "Rate", key: "rate", toLowerCase: () => "rate" },
  { label: "Amount", key: "amount", toLowerCase: () => "amount" },
  { label: "", key: "remove", toLowerCase: () => "amount" },
];

export const CURRENCY_Type = [
  { value: "ngn", label: "ngn" },
  { value: "usd", label: "usd" },
];
